import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.pricingConditions.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.pricingConditions.actionsLoading;
export const getItems = (state:RootState) => state.pricingConditions.items;
export const getItemsSelect = (state:RootState) => state.pricingConditions.dropDownItems;
export const getItemsCount = (state:RootState) => state.pricingConditions.itemsCount;
export const getItemForEdit = (state:RootState) => state.pricingConditions.itemForEdit;
export const getError = (state:RootState) => state.pricingConditions.error;
export const getErrorAction = (state:RootState) => state.pricingConditions.errorAction;
export const validationErrors = (state: RootState) => state.pricingConditions.validationErrors;
export const getFilters = (state: RootState) => state.pricingConditions.filters;
